module.exports = __webpack_public_path__ + "static/media/akankshakate.cb234593.jpg";